import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* 2. WICHTIG: App in BrowserRouter einpacken */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);